import { z } from 'zod';

/** Liens YouTube uniquement ; aucun HTML ni chargement distant côté serveur. */
export function normalizeYouTubeUrl(value: string): string | null {
  if (value.length > 2000) return null;
  let url: URL;
  try { url = new URL(value.trim()); } catch { return null; }
  if (url.protocol !== 'https:' || url.username || url.password || url.port) return null;
  const host = url.hostname;
  const path = url.pathname;
  let id: string | null = null;
  if (host === 'youtu.be') id = /^\/([^/]+)\/?$/.exec(path)?.[1] ?? null;
  if (['youtube.com', 'www.youtube.com', 'm.youtube.com'].includes(host)) {
    id = path === '/watch' ? url.searchParams.get('v') : /^\/(?:shorts|embed|live)\/([^/]+)\/?$/.exec(path)?.[1] ?? null;
  }
  return id && /^[A-Za-z0-9_-]{11}$/.test(id) ? `https://www.youtube.com/watch?v=${id}` : null;
}

export const equipmentVideoInput = z.object({
  id: z.guid(),
  title: z.string().trim().min(1).max(160),
  url: z.string().max(2000).transform((value, ctx) => {
    const normalized = normalizeYouTubeUrl(value);
    if (normalized) return normalized;
    ctx.addIssue({ code: 'custom', message: 'Choisissez un lien vidéo YouTube en https://.' });
    return z.NEVER;
  }),
});

export interface EquipmentVideo {
  id: string;
  title: string;
  url: string;
}
